import React from 'react'
import './css/loading.css'

export default function Loading() {
  return (
    <div id="loading">
      <div className="spinner-border text-primary center-spinner" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  )
}
